import React, { useEffect, useRef, useState } from 'react'

import s from './ai-input.module.sass'

import Button from 'components/button/button'

import { callAssistant } from 'utils/ai'
import { useDispatch, useSelector } from 'react-redux'
import { denormalize } from 'normalizr'
import { projectSchema } from 'state/schemas/schemas'

import {
    createOrReturnAssistantChat,
    sendMessage
} from 'state/actions'

import MessageList from 'components/message-list/message-list'
import ProfilePicture from 'components/profile/profile-picture'
import clsx from 'clsx'

export default function AiInput({
    currentProjectId,
    userData
}) {
    const [inputsHeight, setInputsHeight] = useState(0)
    const hasRequestedChatData = useRef(false)
    const hasSentIntroMessage = useRef(false)

    const [open, setOpen] = useState(false)

    const currentProject = useSelector(state => {
        return denormalize(currentProjectId, projectSchema, state.account.entities)
    })

    const [aiChatIfExists, assistantUser] = useSelector(state => {
        if (!currentProject) {
            return null
        }

        let chat = null
        const user = Object.values(state?.account?.entities?.users)?.find(user => user.is_assistant)

        if (user) {
            chat = Object.values(state?.account?.entities?.chats)?.find(chat => {
                const isWithAssistant = chat.userIds?.includes(user.id)
                const isWithMe = chat.userIds?.includes(userData.id)
                const isCurrentAccount = chat.account_id === currentProject.account_id

                return isWithAssistant && isCurrentAccount && isWithMe
            })
        }

        return [chat, user]
    })

    useEffect(() => {
        if (userData && currentProject && !hasRequestedChatData.current) {
            hasRequestedChatData.current = true

            dispatch(createOrReturnAssistantChat(currentProject.account_id))
        }
    }, [currentProject, userData])

    useEffect(() => {
        if (aiChatIfExists && !aiChatIfExists.chat_items.length && !hasSentIntroMessage.current) {
            hasSentIntroMessage.current = true
            dispatch(sendMessage(aiChatIfExists, `
                Hi, I'm HasslAI!
                <br /><br />
                I'm here to help out with anything you need in Hassl. I can answer questions, update data and create projects from scratch.
            `, [], null, assistantUser.id))
        }
    }, [aiChatIfExists])

    const [value, setValue] = useState('')

    const dispatch = useDispatch()

    const handleSubmit = async e => {
        e.preventDefault()

        dispatch(sendMessage(aiChatIfExists, value))

        setValue('')

        await callAssistant({
            query: value,
            currentProject,
            handleResponse: response => {
                dispatch(sendMessage(aiChatIfExists, response, [], null, assistantUser.id))
            }
        })
    }

    if (!aiChatIfExists || !assistantUser) {
        return null
    }

    return (
        <form
            className={s.Outer}
            onSubmit={handleSubmit}
        >
            <div className={clsx(s.Inner, {
                [s.Open]: open
            })}>
                <div className='dock'>
                    <div className='chats-container'>
                        <ul className='chats'>
                            <li className='open'>
                                <div className='single-chat-container'>
                                    <div className='chat-content'>
                                        <MessageList
                                            typingUserData={null}
                                            hasFetchedAll={true}
                                            fetchRequest={() => { }}
                                            isFetching={false}
                                            type="message"
                                            pendingMessages={[]}
                                            user={userData}
                                            messageObject={aiChatIfExists}
                                            replyEntity={null}
                                            repliedEntity={null}
                                            cancelReplyEntity={null}
                                            typingUsers={[]}
                                            setFocus={() => { }}
                                            optimistic={false}
                                            keyboardHeight={null}
                                            chatId={-1}
                                            inputsHeight={inputsHeight}
                                            updateInputsHeight={setInputsHeight}
                                            hasMounted={true}
                                            isOpen={true}
                                            prepend={(
                                                <div className={s.AssistantPrepend}>
                                                    <ProfilePicture user={assistantUser} isTiny={true} />
                                                    <h2>
                                                        HasslAI
                                                    </h2>
                                                    <p>
                                                        Maecenas nec tellus pulvinar, ullamcorper ipsum non, porta felis.
                                                    </p>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <textarea value={value} onChange={e => setValue(e.target.value)} />
                <div className={s.ButtonRow}>
                    <Button
                        size={'big'}
                        level={'high'}
                        label={'Send'}
                        icon={'check'}
                    />
                </div>
            </div>
            <div className={s.ToggleContainer}>
                <button
                    onClick={() => setOpen(!open)}
                    className={clsx({
                        [s.Open]: open
                    })}
                >
                    &nbsp;
                </button>
            </div>
        </form>
    )
}